import { lazy } from "react";
import { Navigate } from "react-router";
import LogoOnlyLayout from "src/layouts/LogoOnlyLayout";
import SmartRedirect from "src/components/SmartRedirect";
import MainLayout from "../layouts/main";
import Loadable from "./Loadable";

const Maintenance = Loadable(lazy(() => import("src/pages/Maintenance")));
const Page500 = Loadable(lazy(() => import("src/pages/Page500")));
const NotFound = Loadable(lazy(() => import("src/pages/Page404")));
const RegisterWithProduct = Loadable(lazy(() => import("src/pages/auth/RegisterWithProduct")));
const TermsOfService = Loadable(lazy(() => import("src/pages/TermsOfService")));
const EmailChangeResult = Loadable(lazy(() => import("src/pages/EmailChangeResult")));
const EarningsConfigurator = Loadable(lazy(() => import("src/pages/simulator")));

const main = [
  {
    path: "/",
    element: <SmartRedirect />,
  },
  // Public share product page - redirects to registration with product preview
  {
    path: "share/product/:id",
    element: <RegisterWithProduct />,
  },
  // Public, guest-accessible Terms & Conditions page (no auth guard)
  {
    path: "terms-of-service",
    element: <TermsOfService />,
  },
  // Esito cambio email (pubblica): atterraggio del link di verifica inviato
  // dal backend (origin=network). Senza, il redirect finiva sul 404.
  {
    path: "email-change-result",
    element: <EmailChangeResult />,
  },
  // Configuratore Guadagni pubblico (onboarding, no auth): funnel obiettivo-first
  // per prospect. CTA -> registrazione con ref.
  {
    path: "simulator",
    element: <EarningsConfigurator />,
  },
  {
    path: "*",
    element: <LogoOnlyLayout />,
    children: [
      { path: "maintenance", element: <Maintenance /> },
      { path: "500", element: <Page500 /> },
      { path: "404", element: <NotFound /> },
      { path: "*", element: <Navigate to="/404" replace /> },
    ],
  },
];

export default main;
